import { cdnSrc, cdnSrcResize } from '../cdn'

// 根据option创建backgroundImg
export const YBackGroundImage = (src, options) => {
  const cdn = Array.isArray(options) ? cdnSrc(src, options) : cdnSrcResize(src, options)

  return {
    backgroundImage: `url(${cdn})`,
    backgroundSize: 'cover',
  }
}

// background: linear-gradient(-180deg, rgb(255, 236, 196) 0%, rgb(234, 192, 127) 74%, rgb(233, 190, 128) 100%);
// 生成渐变色背景
export const linear = (color: IColorOption[] | string[], deg = 180) => {
  if (!color) return {}
  if (color.length < 1) {
    if (typeof color !== 'string') {
      return { background: (color[0] as IColorOption).color }
    } else {
      return { background: color[0] }
    }
  } else {
    let str = ''

    color.forEach((item, index) => {
      let colorStr = item
      let rate = 100 / (color.length - 1) * index
      if (typeof item !== 'string') {
        colorStr = item.color
        rate = item.rate
      }

      str += `, ${colorStr} ${rate}%`
    })

    return { background: `linear-gradient(${deg}deg${str})` }
  }
}

interface IColorOption {
  color: string;
  rate: number
}